import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { availableOrganizationsKeys } from '../../api/query-keys/available-organizations';
import { AvailableOrganization } from '../../api/types/available-organization';

import { organizationApi } from '@/api/organization-admin/organization';

export const useAvailableOrganizations = (enabled?: boolean) => {
  return useQuery<AvailableOrganization[], ApiError>({
    queryKey: availableOrganizationsKeys.list(),
    queryFn: () => organizationApi.fetchAvailableOrganizations(),
    enabled,
  });
};
